import { FormatType } from '@revelio/iso-utility';

import {
  DEFAULT_GRID_COLUMNS,
  DEFAULT_GRID_ROWS,
} from '../../components/PageConfigProvider/constants';
import type { TabContent } from '../../components/PageConfigProvider/page-reducer';
import {
  type Page,
  PageType,
  RevelioPageId,
} from '../../components/PageConfigProvider/types';
import { FilterId } from '../../filters/types/filters';

const items: TabContent['items'] = [
  {
    id: '5b8102c4-e017-4393-9ca5-4b6249ad42d5',
    title: 'Gender Headcount Share by Role',
    position: { x: 30, y: 0, width: 18, height: 18 },
    plot: {
      chartType: 'diverging-bar-combo',
      secondaryDimension: 'role',
      defaultMetricOptions: ['headcount'],
      format: FormatType.DECIMAL,
      showDataLabels: true,
      hideOther: true,
      divergingBarCombo: {
        subfilterDimension: 'gender',
        dynamicEntityComparison: true,
      },
    },
  },
  {
    id: '2e927256-2bd0-475d-a047-aef7b982d17c',
    title: 'Ethnicity Headcount Share by Role',
    position: { x: 30, y: 18, width: 18, height: 18 },
    plot: {
      chartType: 'diverging-bar-combo',
      secondaryDimension: 'role',
      defaultMetricOptions: ['headcount'],
      showDataLabels: true,
      hideOther: true,
      divergingBarCombo: {
        subfilterDimension: 'ethnicity',
        dynamicEntityComparison: true,
      },
    },
  },
  {
    id: 'f6cec833-858c-490f-abfb-fb279b7e9a6b',
    title: 'Headcount by Gender',
    position: { x: 0, y: 0, width: 15, height: 18 },
    plot: {
      chartType: 'stacked-bar',
      secondaryDimension: 'gender',
      groupBySegment: false,
      adaptive: true,
      defaultMetricOptions: ['headcount'],
      format: FormatType.DECIMAL,
    },
  },
  {
    id: '0b04880e-af9b-4cd6-83d6-4fd445caaec4',
    title: 'Headcount by Ethnicity',
    position: { x: 0, y: 18, width: 15, height: 18 },
    plot: {
      chartType: 'stacked-bar',
      secondaryDimension: 'ethnicity',
      adaptive: true,
      defaultMetricOptions: ['headcount'],
      format: FormatType.DECIMAL,
    },
  },
  {
    id: '2a7866fe-8a64-442e-8e1b-4ee67ae75b20',
    title: 'Gender Headcount Share',
    position: { x: 15, y: 0, width: 15, height: 18 },
    plot: {
      chartType: 'line',
      shareOfSegment: true,
      secondaryDimension: 'gender',
      defaultMetricOptions: ['headcount'],
      format: FormatType.PERCENTAGE,
    },
  },
  {
    id: '24b9d39f-a1a3-4d02-baf3-37ce8c7ecd0a',
    title: 'Ethnicity Headcount Share',
    position: { x: 15, y: 18, width: 15, height: 18 },
    plot: {
      chartType: 'line',
      shareOfSegment: true,
      secondaryDimension: 'ethnicity',
      defaultMetricOptions: ['headcount'],
      format: FormatType.PERCENTAGE,
    },
  },
];

export const companyDiversity: Page = {
  type: PageType.REVELIO_PUBLIC,
  id: RevelioPageId.COMPANY_DIVERSITY,
  revelioPageId: RevelioPageId.COMPANY_DIVERSITY,
  name: 'Diversity',
  owner: { id: 'revelio-labs', username: 'revelio-labs' },
  tabs: [
    {
      id: 'company-diversity',
      label: 'Diversity',
      isActive: true,
      tabContent: {
        id: 'company-diversity',
        grid: { rows: DEFAULT_GRID_ROWS, columns: DEFAULT_GRID_COLUMNS },
        items,
        primaryFilter: { id: FilterId.COMPANY },
        secondaryFilters: [
          FilterId.ACTIVITY,
          FilterId.DATE_RANGE,
          FilterId.EDUCATION,
          FilterId.ETHNICITY,
          FilterId.GENDER,
          FilterId.GEOGRAPHY,
          FilterId.KEYWORDS,
          FilterId.ROLE,
          FilterId.SENIORITY,
          FilterId.CUSTOM_SKILL,
          FilterId.TITLE,
        ].map((id) => ({ id })),
      },
    },
  ],
};
